<div class="app-body">
  <app-header [asideMenuToggler]="false" [fixed]="true" [navbarBrandFull]="{ src: 'assets/img/brand/logo.svg'}"
    [navbarBrandMinimized]="{
      src: 'assets/img/brand/logo_jayaraya.svg',
      width: 41,
      height: 47
    }" [navbarBrandRouterLink]="['/dashboard']" [sidebarToggler]="'lg'">
    <ul class="navbar-nav ml-auto">
      <li id="time" *ngIf="showTime" class="slide-bottom nav-item d-md-down-none" style="margin-top:-200px;width: 300px;text-align:end; position:relative">
        <div id="title" style="margin-bottom:-2px; color:gray;font-size:smaller"></div>
        <div id="subtitle" [ngStyle]="{'color': status === 1 ? 'green' : 'red', 'margin-bottom': '-8px', 'font-size': 'smaller'}"></div>
        <b id="time-cooldown" [ngStyle]="{'color': status === 1 ? 'green' : 'red', 'width': '100px', 'font-size': '1.5rem'}"></b>
      </li>
      <li id="bell-icon" class="nav-item d-md-down-none">
        <a class="nav-link" (click)="toggleShowTime()">
          <i class="fa fa-2x fa-bell"></i>
          <span *ngIf="tglAkhir" class="dot" [ngStyle]="{'background-color': status === 1 ? 'green' : 'red'}"></span>
        </a>
      </li>
      <li class="nav-item d-md-down-none">
        <a class="nav-link mr-3" ngbDropdown>
          <button ngbDropdownToggle class="btn rounded-pill border-0 p-0 pr-3 dropdown-toggle"
            style="background-color: #fecc80; ">
            <button class="btn-circle text-white border-0"
              style="background-color: #e95e0e"><b>{{(pengguna.nama.charAt(0)).toUpperCase()}}</b></button>
            <b class="mr-2 ml-1" style="color: #e95e0e">{{pengguna.nama}}</b>
          </button>
          <div ngbDropdownMenu>
            <button [routerLink]="['/','login']" ngbDropdownItem><a class="icon-logout"
                style="padding-right: 20px"></a>Logout</button>
            <button (click)="openModal()" ngbDropdownItem><a class="icon-settings"
                style="padding-right: 20px"></a>Pengaturan</button>
          </div>
        </a>
      </li>
    </ul>
  </app-header>
  <app-sidebar [display]="'lg'" [fixed]="true" class="shadow-drawer">
    <div class="pengguna-banner">
      <div class="style-12">SELAMAT DATANG
      </div>
      <div class="style-16">{{ pengguna.jabatan }}
      </div>
      <div class="style-12a">{{ pengguna.nip }}
      </div>
    </div>
    <app-sidebar-nav [disabled]="sidebarMinimized" [navItems]="navItems" [perfectScrollbar] class="sidebar-font">
    </app-sidebar-nav>
    <!--    <app-sidebar-minimizer></app-sidebar-minimizer>-->
  </app-sidebar>

  <!-- Main content -->
  <main class="main">
    <ol class="breadcrumb">
      <app-breadcrumb></app-breadcrumb>
    </ol>
    <div class="container-fluid">
      <div class="container-main">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- /.container-fluid -->
  </main>
</div>

<app-footer>
  <span>RBA-BLUD &copy; 2020 DKI</span>
  <span class="ml-auto">PEMERINTAH PROVINSI DKI JAKARTA</span>
</app-footer>
<app-tahun-anggaran> </app-tahun-anggaran>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>